module.exports = __webpack_public_path__ + "static/media/trave_insurance_icon.06e89501.svg";